import React, { Component } from 'react';
import {
  RadioButton,
  FontIcon,
  Checkbox,
} from 'material-ui';

const SmallPreviewTile = props => {
  const {
    sharedProps: {
      downloadType,
      updateDownloadType,
      hoverOver,
      openBigPreview,
      hover,
    },
    type,
    url,
    width,
  } = props;
  return (
    <div
      style={{
        cursor: 'pointer',
        border: downloadType === type ? '2px solid #00bcd4' : '2px solid #e0e0e0',
        position: 'relative',
      }}
      onClick={updateDownloadType(type)}
      data-cy={`format-${type}`}
      onMouseEnter={hoverOver(type)}
      onMouseLeave={hoverOver('')}
    >
      <img
        width={width || '150px'}
        src={url}
      />
      <div
        className="flex-center"
        style={{
          display: hover === type ? 'flex' : 'none',
          position: 'absolute',
          top: 0,
          background:
            'linear-gradient(to bottom, rgba(0,0,0,0.7) 20%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 90%)',
          color: '#fff',
          width: '100%',
          padding: '4px 8px 16px',
          flexDirection: 'row-reverse',
        }}
        onClick={openBigPreview(url)}
      >
        <small>Zoom</small>
        <FontIcon className="tc-icon-zoom_in" color="#fff" style={{ fontSize: '28px' }} />
      </div>
    </div>
  );
};

class RateFormatSelection extends Component {
  constructor() {
    super();
    this.state = {
      showBigPreview: '',
      hover: '',
    };
  }

  componentWillUnmount() {
    this.setState({ showBigPreview: '' });
  }

  render() {
    const {
      updateDownloadType: updateDownloadTypeProp,
      multi,
      downloadType,
    } = this.props;
    const updateDownloadType = type => () => updateDownloadTypeProp(type);
    const openBigPreview = url => () => this.setState({ showBigPreview: url });
    const closeBigPreview = () => this.setState({ showBigPreview: '' });
    const hoverOver = type => () => this.setState({ hover: type });
    const sharedProps = {
      downloadType,
      updateDownloadType,
      hoverOver,
      openBigPreview,
      hover: this.state.hover,
    };
    const summarizedChecked = (() => {
      const type = sharedProps.downloadType || '';
      return type.split('_').splice(0, 2).join('_') === 'quickview_summarized';
    })();
    return (
      <div>
        <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
          <div className="flex-tc-sb">
            <SmallPreviewTile
              sharedProps={sharedProps}
              type="full"
              url="https://tourconnect-production-public.s3.amazonaws.com/contract-download-preview/Full+PDF.png"
            />
            <SmallPreviewTile
              sharedProps={sharedProps}
              type="condensed"
              url="https://tourconnect-production-public.s3.amazonaws.com/contract-download-preview/Condensed+PDF.png"
            />
            <SmallPreviewTile
              sharedProps={sharedProps}
              type="quickview_desummarized"
              width="200px"
              url="https://tourconnect-production-public.s3.amazonaws.com/contract-download-preview/Quickview+Excel.png"
            />
            <SmallPreviewTile
              sharedProps={sharedProps}
              type="quickview_summarized"
              width="200px"
              url="https://tourconnect-production-public.s3.amazonaws.com/contract-download-preview/Quickview+with+Summary+Excel.png"
            />
          </div>
          <div
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'center',
                width: '150px',
              }}
            >
              <RadioButton
                label="Full PDF"
                checked={sharedProps.downloadType === 'full'}
                style={{ margin: '16px auto 8px' }}
                labelStyle={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.87)' }}
                onCheck={updateDownloadType('full')}
              />
              <small style={{ fontSize: '10px' }}>- Contains descriptions</small>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'center',
                width: '150px',
              }}
            >
              <RadioButton
                label="Condensed PDF"
                checked={sharedProps.downloadType === 'condensed'}
                style={{ margin: '16px auto 8px' }}
                labelStyle={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.87)' }}
                onCheck={updateDownloadType('condensed')}
              />
              <small style={{ fontSize: '10px' }}>- Only contains rate related information</small>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'center',
                width: '200px',
              }}
            >
              <RadioButton
                label="Quickview Excel"
                checked={sharedProps.downloadType === 'quickview_desummarized'}
                style={{ margin: '16px auto 8px' }}
                labelStyle={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.87)' }}
                onCheck={updateDownloadType('quickview_desummarized')}
              />
              <small style={{ fontSize: '10px' }}>- All products/seasons/rates appear in a separate row</small>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'center',
                width: '223px',
              }}
            >
              <RadioButton
                label="Quickview w/ Summary Excel"
                checked={summarizedChecked}
                style={{ margin: '16px auto 8px' }}
                labelStyle={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.87)' }}
                onCheck={updateDownloadType('quickview_summarized')}
              />
              {multi && (
                <Checkbox
                  style={{ margin: '0 auto 8px' }}
                  label="Merge into a single sheet"
                  labelStyle={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.87)' }}
                  onCheck={(_event, isChecked) => {
                    if (isChecked) {
                      updateDownloadType('quickview_summarized_singlefile')();
                    } else {
                      updateDownloadType('quickview_summarized')();
                    }
                  }}

                  checked={sharedProps.downloadType === 'quickview_summarized_singlefile'}
                />
              )}
                {/* <div>Merge into a single sheet</div> */}
              <small style={{ fontSize: '10px' }}>- All products/seasons/rates are merged where possible</small>
            </div>
          </div>
        </div>
        <div
          style={{
            display: this.state.showBigPreview ? 'block' : 'none',
            height: '100%',
            width: '100%',
            position: 'fixed',
            zIndex: 1501,
            top: 0,
            left: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            overflow: 'hidden',
            transition: '0.5s',
            textAlign: 'center',
            paddingTop: '32px',
          }}
        >
          <div style={{ textAlign: 'right' }}>
            <FontIcon
              className="tc-icon-close22"
              style={{ color: 'white', marginRight: '48px', cursor: 'pointer', fontSize: '50px' }}
              onClick={closeBigPreview}
            />
          </div>
          <div style={{ overflow: 'scroll', width: '80%', margin: 'auto', height: '80%' }}>
            <img src={this.state.showBigPreview}/>
          </div>
        </div>
      </div>
    );
  }
}

export default RateFormatSelection;



// WEBPACK FOOTER //
// ./src/app/components/settings/mySettings/rate-format-selection.jsx